import type { Pregunta, ValorRespuesta } from '../../api/tipos';

export const valorVacio = (preguntaId: string): ValorRespuesta => ({
  preguntaId,
  opcionIds: [],
});

interface Props {
  pregunta: Pregunta;
  valor: ValorRespuesta;
  deshabilitado: boolean;
  onCambio: (valor: ValorRespuesta) => void;
}

const pastilla = (activa: boolean) =>
  `rounded-full px-4 py-2 text-[13.5px] font-semibold transition-colors ${
    activa
      ? 'border border-cian bg-cian/15 text-celeste'
      : 'border border-white/15 bg-white/[.04] text-suave hover:border-white/30'
  }`;

/// Las opciones de la pregunta como pastillas: una sola elegible en opción
/// única (RADIO), varias en opción múltiple (CHECK).
export function CampoPregunta({ pregunta, valor, deshabilitado, onCambio }: Props) {
  return (
    <div className="flex flex-wrap gap-2.5">
      {pregunta.opciones.map((opcion) => {
        const elegida = valor.opcionIds.includes(opcion.id);

        return (
          <button
            key={opcion.id}
            type="button"
            disabled={deshabilitado}
            className={`${pastilla(elegida)} disabled:cursor-default disabled:opacity-50`}
            onClick={() => {
              if (pregunta.tipo === 'CHECK') {
                const actuales = new Set(valor.opcionIds);
                if (actuales.has(opcion.id)) actuales.delete(opcion.id);
                else actuales.add(opcion.id);
                onCambio({ ...valor, opcionIds: [...actuales] });
                return;
              }
              onCambio({ ...valor, opcionIds: elegida ? [] : [opcion.id] });
            }}
          >
            {opcion.texto}
          </button>
        );
      })}
    </div>
  );
}
